import { render, staticRenderFns } from "./TagPanel.vue?vue&type=template&id=2b601218&scoped=true"
import script from "./TagPanel.vue?vue&type=script&lang=js"
export * from "./TagPanel.vue?vue&type=script&lang=js"
import style0 from "./TagPanel.vue?vue&type=style&index=0&id=2b601218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b601218",
  null
  
)

export default component.exports